import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setUserDocument = document =>
  call(websocketFetch, 'set_user_document', document);
